import { Field } from 'formik'
import { FC } from 'react'
import { TokenGrant } from '../../../types'
import { CheckboxGroup } from '../../organisms/CheckboxGroup'

export const TokenGrantField: FC = () => {
  return (
    <CheckboxGroup>
      <label>
        <Field type='checkbox' name='token' value={TokenGrant.TRUE} />
        Yes
      </label>
      <label>
        <Field type='checkbox' name='token' value={TokenGrant.FALSE} />
        Negotiation
      </label>
    </CheckboxGroup>
  )
}
